<template>
  <v-container fluid>
    <patient-header />
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Дата
            </th>
            <th class="text-left">
              {{ isDoctorViewer ? "Пациент" : "Врач" }}
            </th>
            <th class="text-left">
              Групповая заявка
            </th>
            <th class="text-left">
              Ссылка на конференцию
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.name">
            <td>{{ item.start_at }}</td>
            <td>
              <template v-if="isDoctorViewer">
                {{ item.customer ? item.customer.full_name : "" }}
              </template>
              <template v-else>
                {{ item.doctor ? item.doctor.full_name : "" }}
              </template>
            </td>
            <td>
              <template v-if="item.parent && item.parent.doctor"> Консилиум с доктором {{ item.parent.doctor.name }} </template>
              <template v-else-if="item.additional_doctors && item.additional_doctors.length">
                <div v-for="doc in item.additional_doctors" :key="doc.id">{{ doc.name }}</div>
              </template>
              <div v-else>Нет</div>
            </td>
            <td>
              <v-btn :href="item.link" color="primary" link target="_blank">Консультация</v-btn>
            </td>
            <td>
              <v-btn @click="cancelConsultation(item.id)" color="red">Отменить</v-btn>
            </td>
          </tr>

          <tr v-if="!items.length">
            <td colspan="3">
              <h4>Записи не обнаружены</h4>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import PatientHeader from "@/components/PatientHeader";
export default {
  name: "OnlineConsultationsList",

  components: {
    PatientHeader,
  },

  data() {
    return {
      items: [],
    };
  },

  computed: {
    isDoctorViewer() {
      return this.$store.state.auth.profile?.is_doctor;
    },
  },

  async mounted() {
    if (!this.isDoctorViewer) {
      await this.loadByDoctor();
    } else {
      await this.loadByCustomer();
    }
  },

  methods: {
    async cancelConsultation(id) {
      try {
        const response = await this.$http.delete(`/v1/appointments/${id}`);
        this.items = response.data?.data || [];
      } catch (error) {
        this.$dialog.notify.error("Не удалось отменить консультацию");
      }
    },
    async loadByDoctor() {
      try {
        const response = await this.$http.get("/v1/doctor/appointments");
        this.items = response.data?.data || [];
      } catch (error) {
        this.$dialog.notify.error("Ошибка получения данных");
      }
    },

    async loadByCustomer() {
      try {
        const response = await this.$http.get(`/v1/customer/${this.$store.state.customer.id}/appointments`);
        this.items = response.data?.data || [];
      } catch (error) {
        this.$dialog.notify.error("Ошибка получения данных");
      }
    },
  },
};
</script>

<style scoped></style>
